<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="8" class="mb-3">
                <inter-input
                        label="Titolo"
                        v-model="notice.title"
                        icon="edit"
                        :error="errors.title">
                </inter-input>
            </b-col>
            <b-col cols="12" md="4" class="mb-3">
                <inter-select
                        label="Level"
                        v-model="notice.level"
                        :options="selectLevelsOptions"
                ></inter-select>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Inizio"
                        v-model="notice.start_date"
                        icon="calendar"
                        type="date-autocomplete"
                        :error="errors.start_date">
                </inter-input>
            </b-col>
            <b-col cols="12" md="6" class="mb-3">
                <inter-input
                        label="Fine"
                        v-model="notice.expire_date"
                        icon="calendar"
                        type="date-autocomplete"
                        :error="errors.expire_date">
                </inter-input>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col cols="12" md="12">
                <div class="text-center">
                    <b-form-checkbox v-model="notice.sent_to_all" switch>
                        Notifica a tutte le società
                    </b-form-checkbox>
                </div>
            </b-col>
            <b-col cols="12" md="12" class="mt-3" v-if="!notice.sent_to_all">
                <inter-select
                        :multiple="true"
                        asyncFindAction="select/societies"
                        label="Destinatari"
                        v-model="societies"
                ></inter-select>
            </b-col>
        </b-row>
        <hr>
        <b-row>
            <b-col>
                <inter-rich-text @onEditorUpdate="(value) => {notice.text = value}"></inter-rich-text>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import Notice from "@/models/Notice";
    import InterInput from "../../../components/form/inter-input/InterInput";
    import InterSelect from "../../../components/form/inter-select/InterSelect";
    import InterRichText from "../../../components/inter-rich-text/InterRichText";
    import Utils from '@/utils'
    import _ from "lodash";

    export default {
        name: "AdminNoticesForm",
        components: {InterRichText, InterSelect, InterInput},
        data() {
            return {
                errors: {},
                societies: [],
                levels: Utils.getNoticeLevels(),
            }
        },
        computed: {
            selectLevelsOptions: function () {
                return _.map(this.levels, (item, index) => {
                    return {
                        name: item.name.toUpperCase(),
                        value: index
                    }
                })
            },

        },
        props: {
            notice: {
                type: Object,
                default: () => Object.assign({}, Notice)
            },
        },
        methods: {}
    }
</script>

<style scoped>

</style>
